import React from 'react'
import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import PaymentForm from "./PaymentForm"

//const PUBLIC_KEY = "pk_test_51SUTHuGYNcYWwV8OLNVKemxxM08Rttwd0GutfvRFT8F70mZh50F1aXCm9ZEohSQ4zeCq5r4s06anqKYNu4QovI5200zk040VUT"
const PUBLIC_KEY_LOCAL =  "pk_test_51Sk9V9Aya5vcTN0BovfUMi8fTuvROXwV7g76eDn6vedgCxicR7aYHJIovqyE5YEgxPqwZabrlv8Qz2gR0DzvkNiO000JjKREyn"
const PUBLIC_KEY =  "pk_live_51Sk9V3Pmwra1ZTABHQ365ktOWEaxKQ3isHrwcJsKPvyySNIDzzjkKZeANdVEjy2Lj97r7w4rH6UGYmJ9Wo3V0VKW00pD4Rs0f9"
const stripeTestPromise = loadStripe(PUBLIC_KEY)

export default function StripeContainer({ loggedInUser }) {
    const stripePromise = loadStripe(window.MY_SWITCH.stripePK);
    return(
        <Elements stripe={stripePromise}>
            <PaymentForm 
              loggedInUser={loggedInUser} 
            />
        </Elements>
    )
}